import React, { useEffect, useState } from 'react';
import { Link, useFetcher } from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux';


// import Button from '../component/Button';
// import { open, close, reset } from '../redux/popupSlice';
// import images from '../libs/images';


export default function Popup(props) {

    const {
        title,
        component,
        setClose,
        zIndexs=1000
    } = props;
    const dispatch = useDispatch();

    console.log(component);
    
    // const { 
    //     open, title, titleStyle, content, contentbold, button, buttonCencle, 
    //     onCancelPress, onPress, alert, alertStyle, component, componentExit, style, 
    //     wideOne, titleviewer, buttonviewer
    // } = useSelector(s => s.popupReducer);


    const handleClose = () => {
        // dispatch(close());
        // onCancelPress && onCancelPress();
    };

    const handleSubmit = () => {
        // dispatch(close());
        // onPress && onPress();
    };

    return (
        <>
        
            <div className='PopupArea' style={{zIndex: zIndexs}} >
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => dispatch(close())}
                    />
                    <div className='new_main_popup_container'>
                        <div>
                            <div className='new_main_popup'>
                                <div className='main_popup_title_box'>
                                    <div className='main_popup_title'>
                                        <p>{title}</p>
                                        {/* <img src="./images/icons/vector.svg" width='23.3' style={{ padding: 3.3 }}/> */}
                                    </div>
                                    <img src="./images/icons/x_grey.svg" width='24'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            if(setClose) setClose();
                                        }}
                                    />
                                </div>

                                {component}
                                
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>
        </>
    );
}
